/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import styled from "@emotion/styled";
import moment from 'moment'
import {connect} from 'react-redux'
import { doGoToArticle } from "../4-redux/actions";

function BlogPreviews({ blogData, header, goToArticle }) {
  let i = 0;
  const newestComesFirst = (a, b) =>
    a.fields.datePosted > b.fields.datePosted ? -1 : 1;
  return (
    <Container>
      <Cover>
        <h1>{header}</h1>
      </Cover>
      <Scrollable>
        {blogData.sort(newestComesFirst).map(({fields, sys}) => (
          <Preview key={fields.title} delay={i+=1}>
            <h2>
              <a onClick={() => goToArticle(sys.id)}>{fields.title}</a>
            </h2>
            <p>{fields.preview}</p>
            <Date>{moment(fields.datePosted).fromNow()}</Date>
            <Topic topic={fields.topic}>{fields.topic}</Topic>
          </Preview>
        ))}
      </Scrollable>
    </Container>
  );
}

const actions = {
  goToArticle: doGoToArticle
}

export default connect(null, actions)(BlogPreviews)

const Container = styled.div`
  display: flex;
  margin-right: -2em;
  line-height: 1.6em;
  position: relative;
`;

const Scrollable = styled.div`
  display: flex;
  padding: 4em;
  padding-right: 120px;
  overflow-x: scroll;
  @media (max-width: 600px) {
    padding: 4em 0;
  }
`;

const Date = styled.div`
  color: grey;
  position: absolute;
  bottom: 1em;
  right: 2em;
  font-size: 14px;
`

const Topic = styled.div`
  display: inline-block;
  font-size: 14px;
  color: ${props => {
    switch (props.topic) {
      case 'python':
        return 'lightgreen'
      case 'react':
        return 'turquoise'
      case 'css':
        return 'lightcoral'
      case 'javascript':
        return 'yellow'
    }
  }};
  margin-top: auto;
`

const Preview = styled.div`
  animation: slide-up 0.8s ${({delay}) => delay * 0.05}s backwards;
  height: 450px;
  min-width: 300px;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  box-shadow: -1rem 0 3rem #000;
  background-color: rgb(23, 20, 29);
  border-radius: 16px;
  box-sizing: border-box;
  padding: 1em;
  overflow: hidden;
  opacity: 1;
  transform: translateY(0px);
  margin-right: -100px;
  transition: 0.25s;
  &:hover {
    margin-right: 0;
    transform: translateY(-20px);
  }
  @keyframes slide-up {
    0% {
      opacity: 0;
      transform: translateY(140px);
    }
    70% {
      opacity: 1;
    }
    100% {
      opacity: 1;
    }
  }
`;

const Cover = styled(Preview)`
  background: var(--diagonal-gradient);
  margin-right: 0.5em;
  min-width: 300px;
  max-width: 300px;
  margin-top: 4em;
  padding: 2em;
  cursor: auto;
  box-shadow: none;
  animation: none;
  opacity: 1;
  margin-right: 0;
  &:hover {
    margin-right: 0;
    transform: none;
  }
  display: flex;
  h1 {
    align-self: flex-end;
  }
  @media (max-width: 600px) {
    display: none;
  }
`;
